import axios from 'axios'
import { Notify, Toast } from 'vant'
import router from '@/router'
// 创建axios实例
const service = axios.create({
    baseURL: '/api',
    timeout: 20000
})
// 请求拦截
service.interceptors.request.use(async config => {
    let { isLoading = true, loadingText = '加载中...' } = config
    isLoading && Toast.loading({
        duration: 0,
        message: loadingText,
        forbidClick: true
    })
    if(localStorage.getItem('token')){
        config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    }
    return config
})
// 响应拦截
service.interceptors.response.use(res => {
    Toast.clear()
    let { code, msg } = res.data
    if (code == 401) {
        Notify({ type: 'warning', message: '登录失效，请重新登录' })
        setTimeout(_ => {
            localStorage.clear()
            router.push('/login')
        }, 1000)
        return Promise.reject('token无效')
    }
    if (code == 500) {
        Notify({ type: 'warning', message: msg || '服务器错误' })
        res.data.data = {}
        if(!res.config.next) return Promise.reject('error')
    }
    return res.data
}, err => {
    Toast.clear()
    if(err.message.includes('timeout')){
        Notify({ type: 'warning', message: err.config.name ? err.config.name + '超时' : '请求超时' })
    }
    return {
        code: 1,
        data: {},
        err
    }
})

export default service